<template>
  <div :value="value" v-bind="$attrs">
    <label>
      <v-text-field
        @click="$attrs.click ? '' : (modal = true)"
        :style="(isOnMobile ? 'font-size: 12px;' : '') + (value ? 'background: ' + value : '')"
        class="t-color-picker mytextfield subtitle-2"
        readonly
        :value="value"
        :label="label"
        dense
        hide-details
        :append-icon="color ? '' : 'mdi-brush'"
        :clearable="clearable"
        @click:clear="clearColor()"
        :outlined="outlined"
        :filled="filled"
      ></v-text-field>
    </label>
    <v-dialog v-model="modal" persistent width="290px">
      <v-card>
        <v-color-picker v-model="color" mode="hexa"> </v-color-picker>
        <t-divider></t-divider>
        <v-row class="ma-1 pa-1">
          <v-spacer></v-spacer>
          <v-btn class="ma-1 pa-0" text outlined :style="'background: ' + Colors.MenuColor" :class="Colors.MenuColor + '--text'" @click="clearColor()">Изтрий</v-btn>
          <v-btn class="ma-1 pa-0" text outlined :style="'background: ' + Colors.MenuColor" :class="Colors.MenuColor + '--text'" @click="cancelInput()">Отказ</v-btn>
          <v-btn class="ma-1 pa-0" text outlined :style="'background: ' + Colors.MenuColor" :class="Colors.MenuColor + '--text'" @click="handleInput()">OK</v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    filled: {
      type: Boolean,
      default: false,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    clickable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      modal: false,
      color: null,
      colorLast: null,
    };
  },
  methods: {
    getValue() {
      return this.color ? this.color.hexa : "";
    },
    clearColor() {
      this.color = "";
      this.handleInput();
    },
    cancelInput() {
      this.$emit("cancel", this.colorLast ? this.colorLast.hexa : null);
      this.modal = false;
    },
    handleInput() {
      this.colorLast = this.color;
      if (this.color) {
        this.$emit("input", this.color.hexa);
        this.$emit("change", this.color.hexa);
      } else {
        this.$emit("input", null);
        this.$emit("change", null);
      }
      this.modal = false;
    },
  },
  computed: {},
  watch: {
    value: {
      handler() {
        this.colorLast = this.color;
      },
      deep: true,
    },
  },
  mounted() {},
};
</script>
<style scoped>
.t-color-picker >>> * {
  cursor: pointer;
}
</style>